import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=218cb7fe&scoped=true&"
import script from "./baseTable.vue?vue&type=script&lang=js&"
export * from "./baseTable.vue?vue&type=script&lang=js&"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=218cb7fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218cb7fe",
  null
  
)

export default component.exports